
import React from "react";
import { formatKeyName, formatValue } from "./utils";

interface GenericTierDataProps {
  tierData: any;
}

export default function GenericTierData({ tierData }: GenericTierDataProps) {
  if (!tierData) return <p className="text-white/70">No tier data available</p>;
  
  return (
    <div className="space-y-3">
      {Object.entries(tierData).map(([key, value]) => {
        if (!value) return null;
        
        const formattedKey = formatKeyName(key);
        
        return (
          <div key={key} className="flex">
            <span className="text-white/80 w-40">{formattedKey}:</span>
            <span className="text-white">{formatValue(value)}</span>
          </div>
        );
      })}
    </div>
  );
}
